<template>
  <div id="app">
    <top-header v-if="currentPageType.type!='trade'"></top-header>
    <top-trade v-if="currentPageType.type=='trade'"></top-trade>
    <socket></socket>
    <router-view/>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topHeader from '@/components/topHeaderNew'
import topTrade from '@/components/topHeaderTrade'
import bottomFooter from "@/components/bottomFooter"
import socket from "@/components/socket"
export default {
  name: 'App',
  components: {
    topHeader,
    topTrade,
    bottomFooter,
    socket
  },
  data(){
    return{
    }
  },
  methods:{
    isMobileS() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
                  "SymbianOS", "Windows Phone",
                  "iPad", "iPod"];
      var flag = 0;
      for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) >= 0) {
              flag = 1;
              break;
          }
      }
      localStorage.setItem("isMobile",flag);
    }

  },
  computed:{
    currentPageType(){
      let routerPath = this.$route.meta
      return routerPath
    }
  },
  created(){
    this.isMobileS();
  }
}
</script>
<style lang="less">
@import "../static/js/layer/mobile/need/layer.css";
// @import "assets/js/langage.js";
a{
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/App.vue